import React from 'react'
import styled from 'react-emotion'
import { color, spacer, gradientStart, gradientEnd } from 'stylist'

const ProgressWrapper = styled.div`
  background-image: linear-gradient(
    to right,
    ${({ gradientColor = 'green' }) => gradientStart(gradientColor)},
    ${({ gradientColor = 'green' }) => gradientEnd(gradientColor)}
  );
  width: 100%;
  height: ${spacer(1)};
  border-radius: ${spacer(1)};
`

const Bar = styled.div`
  height: 100%;
  width: ${({ progress }) => 100 - progress}%;
  background-color: ${color('paleGrey')};
  float: right;
`

export const ProgressBar = ({ progress, ...rest }) => (
  <ProgressWrapper {...rest}>
    <Bar progress={progress} />
  </ProgressWrapper>
)

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/ProgressBarV2.js